export default class StripeError {
  error: any;
  reject: () => any;

  constructor(error: any, reject: () => any) {
    this.error = error;
    this.reject = reject;
  }
}
